export default __webpack_public_path__ + "static/media/juicy-lemon.b540de37.png";